import classNames from "classnames";
import React, { useState } from "react";

const SectionMarker = ({
  title = "",
  index,
  isHovered = false,
  setHovered,
  setHoveredIndex,
  isActive = false,
  onClick = () => {}
}) => {
  const [mouseHovered, setMouseHovered] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);

  return (
    <div
      className={classNames("section-marker", {
        active: isActive,
        hovered: isHovered || mouseHovered,
        clicked: mouseDown
      })}
      onClick={e => {
        onClick();
        e.preventDefault();
      }}
      onMouseEnter={() => {
        setMouseHovered(true);
      }}
      onMouseLeave={() => {
        setMouseHovered(false);
      }}
      onPointerDown={() => {
        console.log("onPointerDown");
        setMouseDown(true);
        setHovered(true);
        setHoveredIndex(index);
      }}
      onPointerUp={() => {
        console.log("onPointerUp");
        setMouseDown(false);
        setHovered(false);
        setHoveredIndex(-1);
        //onClick();
      }}
    >
      <div className="dot" />
      <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
    </div>
  );
};

export default SectionMarker;
